<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">
      <h1>{{ $t("Inscrits") }}</h1>
      <br>
      <vx-card  v-if="user_role ==='manager' || user_role==='admin' || user_role==='adminMoozi'" ref="filterCard" title="Filtre" class="user-list-filters mb-4"  >
        <div class="vx-row">
          <div class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
            <p class="mb-2" > Entreprise </p>
            <v-select v-model="corporate" :options="corporates" :reduce="rep => rep.id" label="denomination" autocomplete >
            </v-select>
          </div>
          <div class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
            <p class="mb-2" > Succursale </p>
            <v-select v-model="branch_filter" :options="branches" :reduce="rep => rep.id" label="name" autocomplete >
            </v-select>
          </div>
          <div  class="vx-col w-1/3 sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
            <p class="mb-2" > Numéro de téléphone </p>
            <v-select v-model="phoneNumber_filter" :options="agents" :reduce="rep => rep.phoneNumber" label="phoneNumber" autocomplete >
            </v-select>
          </div>
        </div>
    </vx-card>
    <vx-card  v-if="user_role ==='managerClient' || user_role ==='adminClient'" ref="filterCard" title="Filtre" class="user-list-filters mb-4"  >
        <div class="vx-row">
          <div  class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <p class="mb-2" > Succursale </p>
            <v-select v-model="branch_filter" :options="branches" :reduce="rep => rep.id" label="name" autocomplete >
            </v-select>
          </div>
          <div  class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <p class="mb-2" > Numéro de téléphone </p>
            <v-select v-model="phoneNumber_filter" :options="agents" :reduce="rep => rep.phoneNumber" label="phoneNumber" autocomplete >
            </v-select>
          </div>
        </div>
    </vx-card>
    <div v-if="page" class="w-full flex flex-col items-center my-4">
            <span v-if="page!==100" class="mb-2 text-primary font-semibold text-lg text-center">Téléchargement en cours...</span>
            <span v-if="page===100" class="mb-2 text-primary font-semibold text-lg text-center">Téléchargement terminé.</span>
            <progress-bar class="w-full flex flex-col items-center" :options="options" :value="page"/>
    </div>
      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
  <!-- pagination -->
      <vs-table ref="table"  :max-items="itemsPerPage" search :data="ownerOfPdvs">
  
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
  
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <div
             v-if="user_role !=='agent'"
             class="btn-add-new p-3 mb-5 mr-4 rounded-lg cursor-pointer flex items-center justify-center font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">{{ $t("Ajouter") }}</span>
            </div>
            <download-excel
            v-if="user_role!=='agent'"
            class="btn-add-new icon-user p-2 mb-4 mr-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            header="LISTE DES INSCRITS"
            :fetch= "fetchAllPaginatedOwnerOfPdvs"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="Inscrits.xls"
            >
            Exporter
            </download-excel>

          <div class="flex flex-wrap-reverse items-center data-list-btn-container mb-6" >
            <vs-input label="Entrez l'information "  v-model="search" @keyup.enter="Rech_pdv()" class="w-2/6 mb-6 "/>
          </div>
          <div class="btn-add-new p-2 mb-6 mr-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary" @click="Rech_pdv()">
              <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
          </div>
          <div class="btn-add-new p-2 mb-6 mr-2 ml-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary" @click="Rech_pdv_Reflech()">
              <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
          </div>
          </div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2"><b>{{ count }}</b></span>
            </div>
          </vs-dropdown>
          <!-- ITEMS PER PAGE -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ pageCount }}sur{{ countPages }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAll(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->
        </div>
  
        <template slot="thead">
          <vs-th sort-key="id">N°inscrit</vs-th>
          <vs-th sort-key="Nom_Prenons">{{ $t("Nom_Prenons") }}</vs-th>
          <vs-th sort-key="date_naiss">Date de naissance</vs-th>  
          <vs-th sort-key="Genre">Genre</vs-th>          
          <vs-th sort-key="situation">Situation matrimoniale</vs-th>
          <vs-th sort-key="branch">Succursale</vs-th>
      <!--<vs-th sort-key="localité">Localité</vs-th>-->          
          <vs-th sort-key="Adresse">Adresse</vs-th>
          <vs-th sort-key="Téléphone ">Téléphone </vs-th>
          <vs-th sort-key="Email">Email</vs-th>
      <!--<vs-th sort-key="Entreprise">Entreprise</vs-th>-->          
          <vs-th v-if="user_role!=='agent'"  sort-key="id">télephone agent</vs-th>
          <vs-th sort-key="created_at">{{ $t("created_at") }}</vs-th>
      <!--<vs-th sort-key="updated_at">{{ $t("updated_at") }}</vs-th>-->          
           <vs-th>{{ $t("Action") }}</vs-th>
          </template>
  
          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
  
                <vs-td>
                <p class="product-name font-medium truncate">{{ tr.id}}</p>
                </vs-td>
              
                <vs-td>
                <p class="product-name font-medium truncate">{{ tr.fullName}}</p>
                </vs-td>
  
                <vs-td >
                  <p class="product-name font-medium truncate">{{ tr.birthdate }}</p>
                </vs-td>
  
                <vs-td >
                  <p class="product-name font-medium truncate" >{{  GENDERCHOICES[tr.gender] }}</p>
                </vs-td>
                
                <vs-td>
                  <p  class="product-name font-medium truncate"> {{ tr.maritalStatus == null ? '-' : MARITALSTATUSCHOICES[tr.maritalStatus] }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.branch !== null ? tr.branch.name : '-'}}</p>
                </vs-td>
               <!--  <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.locality || '-'}}</p>
                </vs-td> -->
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.address}}</p>
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.phoneNumber}}</p>
                </vs-td>
                
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.email}}</p>
                </vs-td>

               <!--  <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.corporate}}</p>
                </vs-td> -->
                <vs-td v-if="user_role!=='agent'" >
                <p class="product-name font-medium truncate">{{ tr.author.phoneNumber}}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{tr.created_at | date_time}}</p>
                </vs-td>

                <!-- <vs-td>
                  <p class="product-name font-medium truncate">{{tr.updated_at | date_time}}</p>
                </vs-td> -->
                <vs-td  class="whitespace-no-wrap">
                  <div class="flex">
                    <vx-tooltip v-if="search_rech === true" text="Voir la photo" color="primary">
                      <feather-icon
                        style="color: #438eff"
                        icon="ImageIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                        @click="VoirpictureSearch(tr)"
                      />
                    </vx-tooltip>
                     <vx-tooltip v-if="search_rech === false" text="Voir la photo" color="primary">
                      <feather-icon
                        style="color: #438eff"
                        icon="ImageIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                        @click="Voirpicture(tr)"
                      />
                    </vx-tooltip>
                    <vx-tooltip text="Voir les bénéficiares" v-if="  tr.recipients.length" color="success">
                      <feather-icon
                        style="color: #45a32e"
                        icon="UsersIcon"
                        svgClasses="w-5 h-5 hover:text-success stroke-current"
                        class="mr-2"
                        @click="VoirData(tr)"
                      />
                    </vx-tooltip>
                     <vx-tooltip :text="$t('Modifier')" color="warning">
                      <feather-icon
                        style="color: #FF9F43"
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-warning stroke-current"
                        class="mr-2"
                        @click="editData(tr)"
                      />
                    </vx-tooltip>
<!--                     <vx-tooltip v-if="user_role!=='agent'" :text="$t('Supprimer')" color="danger">
 -->                      
                      <vx-tooltip v-if="user_role==='admin' || user_role==='manager'" :text="$t('Supprimer')" color="danger">
                      <feather-icon
                        @click="deleteData(tr.id)"
                        style="color: red"
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="mr-2"
                      />
                    </vx-tooltip>
  
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
      </vs-table>
      <br>
    <div v-if="!this.verif_filter ">
      <div v-if="this.pageTotal>1" class="flex flex-wrap justify-between my-5" >
      <vs-button  :disabled="pageCount === 1"  v-if="this.repPrev !== null" @click="prev()" class="ml-4 mb-4">Précédent</vs-button>
<!--       <span class="my-5"><b>Page({{pageCount}})/Page({{countPages}})</b></span>
 -->      <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">Page({{ pageCount }}) / Page({{ countPages }})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAll(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      <vs-button  :disabled="pageCount === pageTotal"  v-if="this.repNext !== null" @click="next()" class="ml-4 mb-4" >Suivant</vs-button>
      </div>
    </div>
    <div   v-if="this.verif_filter" >
      <div v-if="this.pageTotal>1" class="flex flex-wrap justify-between my-5" >
      <vs-button  :disabled="pageCount === 1"  v-if="this.prevPage!==null" @click="prev1()" class="ml-4 mb-4">Précédent</vs-button>
<!--         <span class="my-5"><b>Page({{pageCount}})/Page({{countPages}})</b></span>
 -->        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">Page({{ pageCount }}) / Page({{ countPages }})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
              <vs-dropdown-menu  class="dropdown-scroll">
              <vs-dropdown-item
                v-for="n in countPages"
                :key="n"
                @click="paginationAll_filter(n)"
              >
                <span>{{ n }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
      <vs-button  :disabled="pageCount === pageTotal"  v-if="this.nextPage!==null" @click="next1()" class="ml-4 mb-4" >Suivant</vs-button>
      </div>
    </div>
    <vs-popup
    v-if="activePrompt2" 
      fullscreen 
      class="calendar-event-dialog"
      title="Ajouter un inscrit"
      :active.sync="activePrompt2">
      <div class="clearfix">
      <div class="vx-row">
        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
          <!-- NOM ET PRENOMS-->
          <p>Nom & Prénoms <b style="color: #ff6141">*</b></p>
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="fullName"
            v-model="fullName"
            class="w-full"
          />
          <span class="text-danger text-sm" v-show="errors.has('fullName')">{{ errors.first("fullName") }}</span>
  
            <!-- Date de naissance-->
          <p>Date de naissance <b style="color: #ff6141">*</b></p>
          <flat-pickr 
            :config="configdateTimePicker" 
            label-placeholder=" Date"
            v-model="birthdate"
            v-validate="'required'"
            name="birthdate"
            class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('birthdate')">{{ errors.first("birthdate") }}</span>
  
        <p> Genre <b style="color: #ff6141" >*</b> </p>
            <v-select
              v-validate="'required'"
              name="gender"
              :reduce="rep => rep.key"
              class="w-full" label="name"
              v-model="gender"
              :options="genders">
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('gender')">{{ errors.first("gender") }}</span>
        
           
          </div>
  
          <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
  
            <p> Situation matrimoniale <b style="color: #ff6141" ></b> </p>
            <v-select
    
              name="maritalStatus"
              :reduce="rep => rep.key"
              class="w-full" label="name"
              v-model="maritalStatus"
              :options="situations">
            </v-select>

  
            <p>Adresse <b style="color: #ff6141">*</b></p>
            <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="address"
            v-model="address"
            class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first("address") }}</span>
  
            
            <!-- Telephone-->
            <p>Téléphone <b style="color: #ff6141">*</b></p>
            <vue-tel-input
              v-on:country-changed="countryChanged"
              inputOptions.placeholder="Telephone"
              :mode="national"
              :autoFormat="false"
              v-model="phoneNumber"
              data-vv-validate-on="blur"
              name="phoneNumber"
              v-validate="'required'"
            ></vue-tel-input>
            <span class="text-danger text-sm" v-show="errors.has('phoneNumber')">{{errors.first("phoneNumber")}}</span>
  
          </div>
  
        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
          <div>
             <!--EMAIL-->
             <p>Email</p>
            <vs-input
              v-validate="'required|email'"
              data-vv-validate-on="blur"
              name="email"
              type="email"
              v-model="email"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{errors.first("email")}}</span>
  
            <p>Succursale<b style="color: #ff6141">*</b></p>
              <vs-select
                  v-model="branch"
                  v-validate="'required'"
                  autocomplete
                  clearable
                  class="w-full "
                  name="branch"
              >
              <vs-select-item :key="item" :value="item.id" :text="item.name" v-for="item in branches" /></vs-select>
              <span class="text-danger text-sm" v-show="errors.has('branch')">{{errors.first("branch")}}</span>

              <div class="upload-img mt-2">
              <div class="image-container2">
                <img :src="dataImgView6" class="decorated-image2" />
              </div>
              <input  v-validate="'required'" name="name_file6" type="file" class="hidden" ref="uploadImgInput6" @change="updateCurrImg6"  accept="image/*">
              <span>Photo adhérent<b style="color: #ff6141">*</b> :<b v-if="false" style="color:orange">{{ name_file6 }}</b></span>
              <vs-button size="small"  @click="$refs.uploadImgInput6.click()" color="primary" type="filled" icon-pack="feather" icon="icon-image"></vs-button>
              <span class="text-danger text-sm" v-show="errors.has('name_file6')">{{ errors.first("name_file6") }}</span>
              </div>

          </div>
        </div>
        <vx-card class="mt-10" no-shadow card-border>
       <div class="vx-row ">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="FileTextIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Bénéficiaires</span>
          </div>
          <vs-divider />
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <p  >Nom & Prénoms <b style="color: #ff6141">*</b></p>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fullName1"
              v-model="fullName1"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('fullName1')">{{ errors.first("fullName") }}</span>
  
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <p> {{ $t("lien_parente") }} <b style="color: #ff6141" >*</b></p>
            <v-select
              name="beneficier1"
              :reduce="rep => rep.key"
              class="w-full" label="name"
              v-model="recipient1"
              :options="beneficiers">
            </v-select>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <p>Date de naissance <b style="color: #ff6141">*</b></p>
            <flat-pickr 
            :config="configdateTimePicker" 
            label-placeholder=" Date"
            v-model="birthdate1"
            v-validate="'required'"
            name="birthdate_1"
            class="w-full" />
            <span  class="text-danger text-sm" v-show="errors.has('birthdate_1')">{{ errors.first("birthdate") }}</span>
            
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <div  class="upload-img mt-2">
              <div class="image-container2">
                <img :src="dataImgView1_1" class="decorated-image2" />
              </div>
              
              <span>Photo:</span> 
              <span v-if="false"><b style="color:orange">{{ name_file1_1 }}</b></span>
              <input    name="name_file1_1" type="file" class="hidden" ref="uploadImgInput1_1" @change="updateCurrImg1_1" accept="image/*">
              <div class="flex items-center">            
                  <vs-button size="small" class="mr-3" @click="$refs.uploadImgInput1_1.click()" color="primary" type="filled" icon-pack="feather" icon="icon-image"></vs-button>
                  <vs-button size="small" v-if="name_file1_1" class="mr-3" @click="delete_img(name_file1_1, 'name_file1_1')" color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button>
                </div>
            </div>
        </div>

        <div  class="vx-col md:w-full sm:w-full w-full ">
          <div class="flex flex-wrap justify-between mt-5 ">
              <vs-button v-if="!update_produitChek" color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="submit_person">Ajouter</vs-button>
              
              <vs-button v-if="update_produitChek"  color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="update_person">Modifier</vs-button>

              <vs-button   color="danger" type="filled" icon-pack="feather" icon="icon-minus-circle" @click="resetData">Annuler</vs-button>
            </div>
        </div>
        </div>
        <div class="vx-row ">
          <vs-table stripe max-items="4" class="w-full  " pagination search :data="persons_computed">
          <template slot="header">
            <h3>
              Liste des bénéficiaires
            </h3>
          </template>
          <template slot="thead">
            <vs-th hidden>N°</vs-th>
            <vs-th>Nom & Prénoms</vs-th>
            <vs-th>{{ $t("lien_parente") }}</vs-th>
            <vs-th>Date de naissance</vs-th>
            <vs-th>Photo</vs-th>
            <vs-th>Actions</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td hidden :data="tr.id">
                {{ tr.id }}
              </vs-td>
              <vs-td :data="tr.fullName">
                {{ tr.fullName }}
              </vs-td>
              <vs-td :data="tr.recipient">
                {{ tr.recipient ? RECIPIENTCHOICES[tr.recipient] : '-' }}
              </vs-td>
              <vs-td :data="tr.birthdate">
                {{ tr.birthdate }}
              </vs-td>
              <vs-td>
                <img
                  v-if="tr.file"
                  :src="tr.file"
                  alt="Photo"
                  style="max-width: 60px; max-height: 60px; border-radius: 8px; border: 1px solid #eee;"
                />
                <span v-else>-</span>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="flex">
                  <vs-button @click.stop="update_person_chek(tr)" color="warning" size="small" type="filled" icon="edit"></vs-button>
                  <vs-button @click.stop="delete_person(tr)" color="danger" size="small" type="filled" class="ml-2" icon="delete"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
          </vs-table>
        </div>
      </vx-card>

      </div>
      <vs-button color="success"  class="float-right mt-4"  @click="valider" >Envoyer</vs-button>
      </div>
    </vs-popup>
    
    <vs-popup
    v-if="activePrompt1" 
      fullscreen 
      class="calendar-event-dialog"
      title="Modifier un inscrit"
      :active.sync="activePrompt1">
      <div class="clearfix">
      <div class="vx-row">
        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
          <!-- NOM ET PRENOMS-->
          <p>Nom & Prénoms <b style="color: #ff6141">*</b></p>
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="fullName"
            v-model="fullName"
            class="w-full"
          />
          <span class="text-danger text-sm" v-show="errors.has('fullName')">{{ errors.first("fullName") }}</span>
  
            <!-- Date de naissance-->
          <p>Date de naissance <b style="color: #ff6141">*</b></p>
          <flat-pickr 
            :config="configdateTimePicker" 
            label-placeholder=" Date"
            v-model="birthdate"
            v-validate="'required'"
            name="birthdate"
            class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('birthdate')">{{ errors.first("birthdate") }}</span>
  
        <p> Genre <b style="color: #ff6141" >*</b> </p>
            <v-select
              v-validate="'required'"
              name="gender"
              :reduce="rep => rep.key"
              class="w-full" label="name"
              v-model="gender"
              :options="genders">
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('gender')">{{ errors.first("gender") }}</span>
        
           
          </div>
  
          <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
  
            <p> Situation matrimoniale <b style="color: #ff6141" ></b> </p>
            <v-select
    
              name="maritalStatus"
              :reduce="rep => rep.key"
              class="w-full" label="name"
              v-model="maritalStatus"
              :options="situations">
            </v-select>

  
            <p>Adresse <b style="color: #ff6141">*</b></p>
            <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="address"
            v-model="address"
            class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first("address") }}</span>
  
            
            <!-- Telephone-->
            <p>Téléphone <b style="color: #ff6141">*</b></p>
            <vue-tel-input
              v-on:country-changed="countryChanged"
              inputOptions.placeholder="Telephone"
              :mode="national"
              :autoFormat="false"
              v-model="phoneNumber"
              data-vv-validate-on="blur"
              name="phoneNumber"
              v-validate="'required'"
            ></vue-tel-input>
            <span class="text-danger text-sm" v-show="errors.has('phoneNumber')">{{errors.first("phoneNumber")}}</span>
  
          </div>
  
        <div class="vx-col sm:w-full md:w-1/3 lg:1/3 xs:w-full">
          <div>
             <!--EMAIL-->
             <p>Email</p>
            <vs-input
              v-validate="'required|email'"
              data-vv-validate-on="blur"
              name="email"
              type="email"
              v-model="email"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{errors.first("email")}}</span>
  
            <p>Succursale<b style="color: #ff6141">*</b></p>
              <vs-select
                  v-model="branch"
                  v-validate="'required'"
                  autocomplete
                  clearable
                  class="w-full "
                  name="branch"
              >
              <vs-select-item :key="item" :value="item.id" :text="item.name" v-for="item in branches" /></vs-select>
              <span class="text-danger text-sm" v-show="errors.has('branch')">{{errors.first("branch")}}</span>

              <div class="upload-img mt-2">
              <div class="image-container2">
                <img :src="dataImgView6" class="decorated-image2" />
              </div>
              <input  v-validate="'required'" name="name_file6" type="file" class="hidden" ref="uploadImgInput6" @change="updateCurrImg6"  accept="image/*">
              <span>Photo adhérent<b style="color: #ff6141">*</b> :<b v-if="false" style="color:orange">{{ name_file6 }}</b></span>
              <vs-button size="small"  @click="$refs.uploadImgInput6.click()" color="primary" type="filled" icon-pack="feather" icon="icon-image"></vs-button>
              <span class="text-danger text-sm" v-show="errors.has('name_file6')">{{ errors.first("name_file6") }}</span>
              </div>

          </div>
        </div>
        <vx-card class="mt-10" no-shadow card-border>
       <div class="vx-row ">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="FileTextIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Bénéficiaires</span>
          </div>
          <vs-divider />
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <p  >Nom & Prénoms <b style="color: #ff6141">*</b></p>
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="fullName1"
              v-model="fullName1"
              class="w-full"
            />
            <span class="text-danger text-sm" v-show="errors.has('fullName1')">{{ errors.first("fullName") }}</span>
  
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <p> {{ $t("lien_parente") }} <b style="color: #ff6141" >*</b></p>
            <v-select
              name="beneficier1"
              :reduce="rep => rep.key"
              class="w-full" label="name"
              v-model="recipient1"
              :options="beneficiers">
            </v-select>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <p>Date de naissance <b style="color: #ff6141">*</b></p>
            <flat-pickr 
            :config="configdateTimePicker" 
            label-placeholder=" Date"
            v-model="birthdate1"
            v-validate="'required'"
            name="birthdate_1"
            class="w-full" />
            <span  class="text-danger text-sm" v-show="errors.has('birthdate_1')">{{ errors.first("birthdate") }}</span>
            
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <div  class="upload-img mt-2">
              <div class="image-container2">
                <img :src="dataImgView1_1" class="decorated-image2" />
              </div>
              
              <span>Photo:</span> 
              <span v-if="false"><b style="color:orange">{{ name_file1_1 }}</b></span>
              <input    name="name_file1_1" type="file" class="hidden" ref="uploadImgInput1_1" @change="updateCurrImg1_1" accept="image/*">
              <div class="flex items-center">            
                  <vs-button size="small" class="mr-3" @click="$refs.uploadImgInput1_1.click()" color="primary" type="filled" icon-pack="feather" icon="icon-image"></vs-button>
                  <vs-button size="small" v-if="name_file1_1" class="mr-3" @click="delete_img(name_file1_1, 'name_file1_1')" color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button>
              </div>
            </div>
        </div>

        <div  class="vx-col md:w-full sm:w-full w-full ">
          <div class="flex flex-wrap justify-between mt-5 ">
              <vs-button v-if="!update_produitChek" color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="submit_person">Ajouter</vs-button>
              
              <vs-button v-if="update_produitChek"  color="success" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="update_person">Modifier</vs-button>

              <vs-button   color="danger" type="filled" icon-pack="feather" icon="icon-minus-circle" @click="resetData">Annuler</vs-button>
            </div>
        </div>
        </div>
        <div class="vx-row ">
          <vs-table stripe max-items="4" class="w-full  " pagination search :data="persons_computed">
          <template slot="header">
            <h3>
              Liste des bénéficiaires
            </h3>
          </template>
          <template slot="thead">
            <vs-th hidden>N°</vs-th>
            <vs-th>Nom & Prénoms</vs-th>
            <vs-th>{{ $t("lien_parente") }}</vs-th>
            <vs-th>Date de naissance</vs-th>
            <vs-th>Photo</vs-th>
            <vs-th>Actions</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td hidden :data="tr.id">
                {{indextr }}
              </vs-td>
              <vs-td hidden :data="tr.id">
                {{ tr.id }}
              </vs-td>
              <vs-td :data="tr.fullName">
                {{ tr.fullName }}
              </vs-td>
              <vs-td :data="tr.recipient">
                {{ tr.recipient ? RECIPIENTCHOICES[tr.recipient] : '-' }}
              </vs-td>
              <vs-td :data="tr.birthdate">
                {{ tr.birthdate }}
              </vs-td>
              <vs-td>
                <img
                  v-if="tr.file"
                  :src="tr.file"
                  alt="Photo"
                  style="max-width: 60px; max-height: 60px; border-radius: 8px; border: 1px solid #eee;"
                />
                <span v-else>-</span>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="flex">
                  <vs-button @click.stop="delete_person_file(tr)" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-camera-off"></vs-button>
                  <vs-button @click.stop="update_person_chek(tr)" color="warning" size="small" type="filled" class="ml-2" icon="edit"></vs-button>
                  <vs-button @click.stop="delete_person(tr)" color="danger" size="small" type="filled" class="ml-2" icon="delete"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
          </vs-table>
        </div>
      </vx-card>

      </div>
      <vs-button color="success"  class="float-right mt-4"  @click="valider" >Envoyer</vs-button>
      </div>
      </vs-popup>
    <vs-popup
      v-if="activePrompt4"
      class="calendar-event-dialog popup-secondaire "
      :title="name_img"
      :class="{ zoomed: isZoomed }"
      @click.stop="toggleZoom"
      :active.sync="activePrompt4">
      <div class="image-container">
        <img :src="imageUrl" class="decorated-image" />
      </div>
     <!--  <div class="flex justify-center mt-4 space-x-4">
      <vs-button @click="close_img" color="primary" type="filled" icon-pack="feather" icon="icon-x-circle">
        Annuler
      </vs-button>
      <vs-button @click="delete_img" color="danger" type="filled" icon-pack="feather" icon="icon-trash">
        Supprimer
      </vs-button>
      </div> -->
    </vs-popup>
      
    <vs-popup
    v-if="activePrompt3" 
      fullscreen
      class="calendar-event-dialog"
      title="VOIR LES BÉNÉFICIAIRES"
      :active.sync="activePrompt3">
      <vs-table stripe  search  :data="bene_object">
        <template slot="header">
          <h3>
            Bénéficiaire
          </h3>
        </template>
        <template slot="thead">
          <vs-th>Nom complet</vs-th>
          <vs-th>Date de naissance</vs-th>
          <vs-th>Situation</vs-th>
          <vs-th>Photo</vs-th>
          <vs-th>Action</vs-th>

        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td>
              <p  class="product-name font-medium truncate">{{ tr.fullName}}</p>
            </vs-td>
            <vs-td>
              <p  class="product-name font-medium truncate">{{ tr.birthdate}}</p>
            </vs-td>
            <vs-td>
              <p  class="product-name font-medium truncate"> {{ tr.recipient == null ? '-' : RECIPIENTCHOICES[tr.recipient] }}</p>
            </vs-td>
           
            <vs-td>
            <img
              v-if="tr.file"
              :src="tr.file"
              alt="Photo"
              style="max-width: 60px; max-height: 60px; border-radius: 8px; border: 1px solid #eee;"
            />
            <span v-else>-</span>
            </vs-td>
             <vs-td>
               <vs-button v-if="tr.file"  @click.stop="openfiles(tr.file)" color="warning" size="small" type="filled" icon-pack="feather" icon="icon-eye">Voir</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    </div>
  </template>
  
<script>
// For custom error message
import { Validator } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
const French = require('flatpickr/dist/l10n/fr.js').default.fr
const link = 'https://form.grouptransvie.com/uploads/'
const str = 'https://form.grouptransvie.com/api/'

const dict = {
  custom: {
    fullName: {
      required: 'Le champ nom et prénom est obligatoire'
    },
    fullName1: {
      required: 'Le champ nom et prénom est obligatoire'
    }, 
   
    gender: {
      required: 'Le champ genre est obligatoire'
    },
    birthdate: {
      required: 'Le champ date est obligatoire'
    },
    birthdate1: {
      required: 'Le champ date est obligatoire'
    }, 
   
    phoneNumber: {
      required: 'Le champ téléphone est obligatoire',
      min: 'Au minimum 8 caractères.',
      max: 'Au minimum 8 caractères.'
    },
     
    email: {
      required: 'Le champ email est obligatoire',
      email:'E-mail incorrecte'
    },
  
    /*  corporate: {
      required: 'Le champ entreprise est obligatoire'
    },
   */
    address: {
      required: 'Le champ adresse est obligatoire'
    },
  
    maritalStatus: {
      required: 'Le champ situation est obligatoire'
    },
  
    /* locality: {
      required: 'Le champ localité est obligatoire'
    }, */
    branch: {
      required: 'Le champ succursale est obligatoire'
    },

    name_file6:{
      required : 'La photo est obligatoire '
    },
    name_file1_1:{
      required : 'La photo est obligatoire '
    }
  
  }
}
  
// register custom messages
Validator.localize('en', dict)
  
export default {
  components: {
    flatPickr      
  },
  data () {
    return {
      options: {
        text: {
          color: '#222B45',           // Texte foncé pour la lisibilité
          shadowEnable: true,
          shadowColor: '#E0E0E0',     // Ombre douce
          fontSize: 16,               // Texte un peu plus grand
          fontFamily: 'Montserrat, Helvetica, Arial, sans-serif', // Police moderne
          dynamicPosition: false,      // Position dynamique du texte
          hideText: false
        },
        progress: {
          color: '#2dbd2d', // Dégradé violet/vert
          backgroundColor: '#F4F5FA', // Fond clair
          inverted: false
        },
        layout: {
          height: 30,                 // Barre plus épaisse
          width: 180,                 // Plus large
          verticalTextAlign: 50,      // Centrage vertical
          horizontalTextAlign: 50,    // Centrage horizontal
          zeroOffset: 0,
          strokeWidth: 20,            // Bord plus fin
          progressPadding: 2,         // Petit espace autour
          type: 'line',
          borderRadius: 12            // Bords arrondis
        }
      },
      itemIndexProduit:-1,
      update_produitChek : false,
      Has_Med_Dos_Qty_update : false,
      id_produit:1,
      persons_computed:[],
      person_submit: [],
      dataImgView1_1:'',    
      dataImgView6:'',
      title_img:'',
      isZoomed: false,
      name_img:'',
      imageUrl:'',
      rechCheck:false,
      pageTotal:1,
      pageCount:1,
      count:0,
      search_rech:false,
      search:'',
      branch_up:'',
      verif_filter:false,
      repNext:'',
      repPrev: '',
      prevPage: '',
      nextPage: '',
      checkId:[],
      updatecreate:false,
      phoneNumber_filter:'',
      branch_filter:'',
      json_fields: {
        'N°': 'id',
        'NOM & PRÉNOMS': 'fullName',
        'DATE DE NAISSANCE': 'birthdate',
        'GENRE': 'gender',
        'SITUATION MATRIMONIALE':'maritalStatus',
        'BRANCHE': 'branch.name',
        'EMAIL':'email',
        'TÉLÉPHONE INSCRIT':'phoneNumber',
        'TÉLÉPHONE AGENT':'author.phoneNumber'
      },
      id:null,
      user_role:'',
      activePrompt4:false,
      activePrompt3:false,
      activePrompt2:false,
      activePrompt1:false,
      GENDERCHOICES: {
        male: 'Masculin',
        female:'Feminin'
      },
      RECIPIENTCHOICES: {
        child: 'Enfant',
        wifeorhusband:'Epoux(se)'
      },
      MARITALSTATUSCHOICES: {
        single:'Célibataire',
        married: 'Marié',
        divorced:'Divorcé',
        widowed:' Veuf(ve)'
      },
      ownerOfPdvs: [],
      selected: [],
      itemsPerPage: 50,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      configdateTimePicker: {
        enableTime: 'fasle',
        dateFormat: 'Y-m-d',
        locale: French
      },
      beneficiers: [
        {
          key: 'wifeorhusband',
          name: 'Epoux(se)'
        },
        {
          key: 'child',
          name: 'Enfant'
        }
      ],
      genders: [
        {
          key: 'male',
          name: 'Masculin'
        },
        {
          key: 'female',
          name: 'Féminin'
        }
      ],
      situations: [
        {
          key: 'single',
          name: 'Célibataire'
        },
        {
          key: 'married',
          name: 'Marié(e)'
        },        
        {
          key: 'divorced',
          name: 'Divorcé'
        },        
        {
          key: 'widowed',
          name: 'Veuf(ve)'
        }
      ],
      corporates:[],
      fullName:'',
      fullName1:'',
      
      gender:'',
      phoneNumber:'',
      birthdate:'',
      birthdate1:'',
      
      address:'',
      corporate:'',
      maritalStatus:'',
      //locality:'',
      memberPicture:'',
      email:'',
      branch:'',
      recipient1:null,
      
      branches:[],
      countryCode: '',
      name_file1_1:'',
      
      name_file6:'',
      dataImg1_1:'',
     
      dataImg6:'',

      date1 : 0,
      
      agents:[],

      page: 0,
      isDestroyed: false,
      corporate_value:''

     
    }
  },
  watch: {
    corporate (value) {
      if (value) {
        //this.ownerOfPdvs = []
        this.rechCheck = false
        this.verif_filter = true
        this.corporate_value = value
        const phoneNumber = this.phoneNumber_filter
        const branch = this.branch_filter
        const corporate = this.corporate
        this.$vs.loading()
        this.$http.post('owner-filter-paginated/', { corporate, phoneNumber, branch})
          .then((response) => {
            if (response.data.results.length !== 0) {
              this.count = 0
              this.pageCount = 1
              this.count = response.data.count
              this.ownerOfPdvs = response.data.results
              this.nextPage = str + (response.data.next).substr(34)
              this.prevPage = str + (response.data.previous).substr(34)
              this.$vs.loading.close()
            } else {
              this.count = 0
              this.ownerOfPdvs = []
              this.$vs.loading.close()
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.corporate_value = ''
        this.verif_filter = false
        this.search_rech =  false
        this.getpaginatedownerOfPdvs()
      }
    },
    phoneNumber_filter (value) {
      if (value) {
        //this.ownerOfPdvs = []
        this.rechCheck = false
        this.verif_filter = true
        this.phoneNumber_up = value
        const phoneNumber = this.phoneNumber_up
        const branch = this.branch_filter
        const corporate = this.corporate
        this.$vs.loading()
        this.$http.post('owner-filter-paginated/', { phoneNumber, branch, corporate})
          .then((response) => {
            if (response.data.results.length !== 0) {
              this.count = 0
              this.pageCount = 1
              this.count = response.data.count
              this.ownerOfPdvs = response.data.results
              this.nextPage = str + (response.data.next).substr(34)
              this.prevPage = str + (response.data.previous).substr(34)
              this.$vs.loading.close()
            } else {
              this.count = 0
              this.ownerOfPdvs = []
              this.$vs.loading.close()
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.phoneNumber_up = ''
        this.verif_filter = false
        this.search_rech =  false
        this.getpaginatedownerOfPdvs()
      }
    },
    branch_filter (value) {
      if (value) {
        //this.ownerOfPdvs = []
        this.rechCheck = false
        this.verif_filter = true
        const phoneNumber = this.phoneNumber_up
        const corporate = this.corporate
        this.branch_up = value
        const branch = this.branch_up
        this.$vs.loading()
        this.$http.post('owner-filter-paginated/', { branch, phoneNumber, corporate})
          .then((response) => {
            if (response.data.results.length !== 0) {
              this.count = 0
              this.pageCount = 1
              this.ownerOfPdvs = response.data.results
              this.count = response.data.count
              this.nextPage = str + (response.data.next).substr(34)
              this.prevPage = str + (response.data.previous).substr(34)
              this.$vs.loading.close()
            } else {
              this.count = 0
              this.ownerOfPdvs = []
              this.$vs.loading.close()
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.branch_up = ''
        this.verif_filter = false
        this.search_rech =  false
        this.getpaginatedownerOfPdvs()
      }
    },
    /* ,    birthdate1 (value) {
      if (value) {
        const birthdate = value
        this.$vs.loading()
        this.$http.post('recipient-age/', { birthdate})
          .then((response) => {
            this.date1 = response.data.age
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

      } 
    }*/ 

    count (newVal) {
      if (this.isMounted && newVal > 50) {
        this.pageTotal = Math.ceil(newVal / 50)
      } else {
        this.pageTotal = 1
      }
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    countPages () {
      if (this.isMounted && this.count > 50) {
        return Math.ceil(this.count / 50)
      }
      return 1
    },
    countPagesResulte () {
      if (this.count > 50) {
        return true
      }
      return false
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.ownerOfPdvs.length
    }
  },
  methods: {
    submit_person () {

      // Validation des champs obligatoires
      if (
        !this.fullName1 ||
        !this.recipient1 ||
        !this.birthdate1
      ) {
        this.$vs.notify({
          color: 'warning',
          title: 'Attention',
          text: 'Veuillez remplir tous les champs obligatoires du bénéficiaire.',
          position: 'top-center'
        })
        return
      }
      // Création de l'objet personne
      const person = {
        id_person: this.id_produit++,
        fullName: this.fullName1,
        recipient: this.recipient1,
        birthdate: this.birthdate1,
        file: this.dataImgView1_1,
        file_object: this.dataImg1_1,
        file_name: this.name_file1_1
      }

      // Vérification de l'existence (par nom et date de naissance)
      const exists = this.persons_computed.some(
        p => p.fullName === person.fullName
      )

      if (exists) {
        this.$vs.notify({
          color: 'warning',
          title: 'Attention',
          text: 'Cette personne existe déjà dans la liste des bénéficiaires.',
          position: 'top-center'
        })
        return
      }

      // Ajout à la liste
      this.persons_computed.push(person)

      // Réinitialisation des champs du formulaire bénéficiaire
      this.fullName1 = ''
      this.recipient1 = null
      this.birthdate1 = ''
      this.dataImgView1_1 = ''
      this.name_file1_1 = ''
      this.dataImg1_1 = ''

      // Optionnel : notifier l'utilisateur
      this.$vs.notify({
        color: 'success',
        title: 'Succès',
        text: 'Bénéficiaire ajouté avec succès.',
        position: 'top-center'
      })
    },

    update_person_chek (person) {
      // Remplit les champs du formulaire bénéficiaire avec les données de la personne sélectionnée
      this.id_person = person.id_person
      this.fullName1 = person.fullName
      this.recipient1 = person.recipient
      this.birthdate1 = person.birthdate
      this.dataImgView1_1 = person.file
      this.dataImg1_1 = person.file_object
      this.name_file1_1 = person.file_name
      this.update_produitChek = true
    },
    update_person () {
      // Validation des champs obligatoires
      if (
        !this.fullName1 ||
    !this.recipient1 ||
    !this.birthdate1
      ) {
        this.$vs.notify({
          color: 'warning',
          title: 'Attention',
          text: 'Veuillez remplir tous les champs obligatoires du bénéficiaire.',
          position: 'top-center'
        })
        return
      }

      // Trouver l'index de la personne à mettre à jour
      const index = this.persons_computed.findIndex(p => p.id_person === this.id_person)
      if (index !== -1) {
        // Mettre à jour les données
        this.$set(this.persons_computed, index, {
          id_person: this.id_person,
          fullName: this.fullName1,
          recipient: this.recipient1,
          birthdate: this.birthdate1,
          file: this.dataImgView1_1,
          file_object: this.dataImg1_1,
          file_name: this.name_file1_1
        })

        // Réinitialiser le formulaire et l'état d'édition
        this.fullName1 = ''
        this.recipient1 = null
        this.birthdate1 = ''
        this.dataImgView1_1 = ''
        this.name_file1_1 = ''
        this.dataImg1_1 = ''
        this.update_produitChek = false

        this.$vs.notify({
          color: 'success',
          title: 'Succès',
          text: 'Bénéficiaire mis à jour avec succès.',
          position: 'top-center'
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Erreur',
          text: 'Bénéficiaire introuvable.',
          position: 'top-center'
        })
      }
    },
    delete_person_file (tr) {
      // Efface la photo du bénéficiaire sélectionné dans la liste persons_computed
      const index = this.persons_computed.findIndex(p => p.id_person === tr.id_person)
      if (index !== -1) {
        // On efface les champs liés à la photo
        this.$set(this.persons_computed, index, {
          ...this.persons_computed[index],
          file: 1,
          file_object: '',
          file_name: ''
        })
        this.$vs.notify({
          color: 'success',
          title: 'Succès',
          text: 'Photo du bénéficiaire supprimée.',
          position: 'top-center'
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Erreur',
          text: 'Bénéficiaire introuvable.',
          position: 'top-center'
        })
      }
    },

    delete_person (person) {
      // Supprimer la personne de la liste
      const index = this.persons_computed.findIndex(p => p.id_person === person.id_person)
      if (index !== -1) {
        this.persons_computed.splice(index, 1)
        this.$vs.notify({
          color: 'success',
          title: 'Succès',
          text: 'Bénéficiaire supprimé avec succès.',
          position: 'top-center'
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Erreur',
          text: 'Bénéficiaire introuvable.',
          position: 'top-center'
        })
      }
    },
    resetData () {
      this.id_person = ''
      this.fullName1 = ''
      this.recipient1 = null
      this.birthdate1 = ''
      this.dataImgView1_1 = ''
      this.name_file1_1 = ''
      this.dataImg1_1 = ''
      this.update_produitChek = false
    }, 
  
    saveEditTeste () {
      const produits_store = this.persons_computed
      for (let i = 0; i < produits_store.length; i++) {
        this.New_produitID.push(produits_store[i].id)
      }
      for (let i = 0; i < this.New_produitID.length; i++) {
        const supprOp = this.New_produitID[i]
        this.removeItemAll(this.old_produitID, supprOp)
      }

    },
    delete_img (title, name) {
      if (name === 'name_file1_1') {
        this.name_file1_1 = ''
        this.dataImg1_1 = ''
        this.dataImgView1_1 = ''
        this.activePrompt4 = false
      }
    },
    close_img () {
      this.activePrompt4 = false
      this.isZoomed = false
    },
    toggleZoom () {
      this.isZoomed = !this.isZoomed
    },
    /*  showViewer (img, name) {
      this.title_img = name
      this.name_img = img
      this.imageUrl = link + img
      this.activePrompt4 = true
    }, */
    countNext () {
      if (this.pageTotal > this.pageCount) {
        if (this.pageCount <= this.count) { this.pageCount = this.pageCount + 1 }
      }
    },
    countPrev () {
      if (this.count > 50) {
        if (this.pageCount > 1) {
          this.pageCount = this.pageCount - 1
        }
      }
    },
    paginationAll_filter (npage) {
      this.$vs.loading()
      this.$http.post(`${str}owner-filter-paginated/?page=${npage}`, {
        phoneNumber:this.phoneNumber_up,
        branch:this.branch_up
      })
        .then((response) => {
          this.pageCount = npage
          this.count = 0
          this.ownerOfPdvs = response.data.results
          this.count = response.data.count
          this.nextPage = str + (response.data.next).substr(34)
          this.prevPage = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    paginationAll (npage) {
      this.$vs.loading()
      this.$http.get(`${str}paginated-ownerOfPdvs/`, { params: {page: npage} })
        .then((response) => {
          this.pageCount = npage
          this.count = 0
          this.ownerOfPdvs = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    next () {
      this.$vs.loading()
      this.$http.get(this.repNext)
        .then((response) => {
          this.countNext()
          this.count = 0
          this.ownerOfPdvs = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev () {
      this.$vs.loading()
      this.$http.get(this.repPrev)
        .then((response) => {
          this.countPrev()
          this.count = 0
          this.ownerOfPdvs = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    next1 () {
      this.$vs.loading()
      this.$http.post(this.nextPage, {
        phoneNumber:this.phoneNumber_up,
        branch:this.branch_up
      })
        .then((response) => {
          this.countNext()
          this.count = 0
          this.ownerOfPdvs = response.data.results
          this.count = response.data.count
          this.nextPage = str + (response.data.next).substr(34)
          this.prevPage = str + (response.data.previous).substr(34)
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    prev1 () {
      this.$vs.loading()
      this.$http.post(this.prevPage, {
        phoneNumber:this.phoneNumber_up,
        branch:this.branch_up
      }).then((response) => {
        this.countPrev()
        this.count = 0
        this.ownerOfPdvs = response.data.results
        this.count = response.data.count
        this.nextPage = str + (response.data.next).substr(34)
        this.prevPage = str + (response.data.previous).substr(34)
        this.$vs.loading.close()
      }).catch(() => {
        this.$vs.loading.close()
      })
    },
    Rech_pdv_Reflech () {
      this.search_rech = false
      this.rechCheck = false
      this.page = 0
      this.search = ''
      this.getpaginatedownerOfPdvs()
    },
    Rech_pdv () {
      if (this.search) {
        this.$vs.loading()
        this.rechCheck = true
        this.search_rech = true
        const search = this.search
        this.$http.post('search-owner-of-pdv/', { search })
          .then((response) => {
            this.pageCount = 1
            this.count = 0
            this.count = response.data.count
            this.ownerOfPdvs = response.data.results
            this.repNext = str + (response.data.next).substr(34)
            this.repPrev = response.data.previous
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else if (this.search === '') {
        this.$vs.notify({
          time:4000,
          title: 'ATTENTION',
          text: 'Entrez l\'information.',
          color: 'warning',
          position:'top-center'
        })
        this.$vs.loading.close()
      }

    },
    Rech () {
      if (this.phoneNumber !== '') {
        this.$vs.loading()
        const phoneNumber = this.phoneNumber
        this.$http.post('owner-filter-paginated/', { phoneNumber })
          .then((response) => {
            this.ownerOfPdvs = response.data
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.notify({
              time:4000,
              title: 'ATTENTION',
              text: 'Entrez un numéro de téléphone.',
              color: 'warning',
              position:'top-center'
            })
            this.$vs.loading.close()
          })
      } else {
        this.$vs.notify({
          time:4000,
          title: 'ATTENTION',
          text: 'Entrez un numéro de téléphone.',
          color: 'warning',
          position:'top-center'
        })
        this.$vs.loading.close()
      }

    },
    async fetchData () {
      const response = this.ownerOfPdvs

      const maritalStatusMap = {
        single: 'Célibataire',
        married: 'Marié',
        divorced: 'Divorcé',
        widowed: 'Veuf(ve)'
      }

      const genderMap = {
        male: 'Masculin',
        female: 'Féminin'
      }

      const transformedResponse = response.map(item => ({
        ...item,
        maritalStatus: maritalStatusMap[item.maritalStatus] || item.maritalStatus,
        gender: genderMap[item.gender] || item.gender
      }))

      return transformedResponse
    },
    addNewData () {
      this.intialise()
      this.activePrompt2 = true
    },
    intialise () {
      this.persons_computed = []
      this.dataImgView1_1 = ''
      this.dataImgView6 = ''  
      this.title_img = ''
      this.search = ''
      this.fullName = ''
      this.id = null
      this.fullName1 = ''
      this.branch = ''
      this.gender = ''
      this.phoneNumber = ''
      this.birthdate = ''
      this.birthdate1 = ''
      this.address = ''
      //this.corporate = ''
      this.maritalStatus = ''
      //this.locality = ''
      this.particularCaseFiles = ''
      this.memberPicture = ''
      this.email = ''
      this.recipient1 = null
      this.name_file1_1 = ''
      this.name_file6 = ''
      this.dataImg1_1 = ''
      this.dataImg6 = ''
      this.date1 = 0
    },
  
    updateCurrImg1_1 (input) {
      if (input.target.files && input.target.files[0]) {
        this.dataImg1_1 = input.target.files
        this.name_file1_1 = input.target.files[0].name
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImgView1_1 = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    
  
    updateCurrImg6 (input) {
      if (input.target.files && input.target.files[0]) {
        this.dataImg6 = input.target.files
        this.name_file6 = input.target.files[0].name
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImgView6 = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    valider () {
      // Validation des champs obligatoires de l'inscrit principal
      const vide = ''
      if (
        !this.fullName ||
    !this.birthdate ||
    !this.gender ||
    !this.address ||
    !this.phoneNumber ||
    !this.email ||
    !this.branch
      ) {
        this.$vs.notify({
          color: 'warning',
          title: 'Attention',
          text: 'Veuillez remplir tous les champs obligatoires de l’inscrit.',
          position: 'top-center'
        })
        return
      }

      const recipients = this.persons_computed.map(b => ({
        recipient: b.recipient,
        fullName: b.fullName,
        birthdate: b.birthdate,
        file_object: b.file_object || '',
        file: b.file || ''
      }))
     
      const formdata = new FormData()
      formdata.append('fullName', this.fullName)
      formdata.append('address', this.address)
      formdata.append('branch', this.branch)
      formdata.append('birthdate', this.birthdate)
      formdata.append('gender', this.gender)
      formdata.append('email', this.email)
      formdata.append('maritalStatus', this.maritalStatus || '')
      formdata.append('phoneNumber', this.phoneNumber)
      if (this.dataImg6) {
        formdata.append('memberPicture', this.dataImg6[0], this.name_file6)
      } else {
        formdata.append('memberPicture', '')
      }

      // Ajout des bénéficiaires dans le FormData
     
      if (recipients.length > 0) {
        recipients.forEach((file, index) => {
          if (file.file_object[0] instanceof File) {
            formdata.append(`file_${index}`, file.file_object[0], file.file_object[0].name)
          } else if (typeof file.file === 'string') {
            //this.vide
          } else if (file.file === 1) {
            formdata.append(`file_${index}`, vide)
          } else {
            formdata.append(`file_${index}`, vide)
          }

        })
        const recipients_last = this.persons_computed.map(b => ({
          recipient: b.recipient,
          fullName: b.fullName,
          birthdate: b.birthdate
        }))
        formdata.append('recipients', JSON.stringify(recipients_last))

      } else {
        formdata.append('recipients',  '[]')
      }
     
      this.$vs.loading()

      let url = 'ownerOfPdvs/'
      let method = 'post'
      if (this.id) {
        url += `${this.id}/`
        method = 'patch'
      } 

      this.$http[method](url, formdata)
        .then(response => {
          this.$vs.loading.close()
          if (this.id) {
            this.updatecreate = true
            this.UPDATE_TASK(response.data)
            this.activePrompt1 = false
          } else {
            this.updatecreate = true
            this.ownerOfPdvs.unshift(response.data)
          }
          this.$vs.notify({
            title: this.id ? 'MISE À JOUR' : 'INSCRIPTION',
            text: this.id ? 'Inscription modifiée avec succès.' : 'Inscription avec succès.',
            color: 'success',
            position: 'top-center'
          })
          this.intialise()
          this.$validator.reset()
        })
        .catch(error => {
          const clefs = Object.keys(error.response.data)
          for (let i = 0; i < clefs.length; i++) {
            const item = clefs[i]
            this.$vs.notify({
              time: 4000,
              title: 'ATTENTION',
              text: `Erreur sur le champ : ${this.$t(item)}`,
              color: 'warning',
              position: 'top-center'
            })
          }
          this.$vs.notify({
            time: 8000,
            title: 'ENREGISTREMENT',
            text: 'L\'enregistrement a échoué',
            color: 'danger',
            position: 'top-right'
          })
          this.$vs.loading.close()
        })
    },
    deleteData (id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('enteteDelete'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http.delete(`ownerOfPdvs/${id}/`)
            .then(response => {
              //this.getAllownerOfPdvs()
              this.REMOVE_ITEM_PRODUIT_INSCRIT(id)
              window.getPrendTaCom.success(this.$t('SuppressionPVD'), response)
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('Suppression')})
            })
        }
      })
  
    },
    REMOVE_ITEM_PRODUIT_INSCRIT (produitId) {
      this.$vs.loading.close()
      const ItemIndex = this.ownerOfPdvs.findIndex((p) => p.id === produitId)
      this.ownerOfPdvs.splice(ItemIndex, 1)
    },
    UPDATE_TASK (task) {
      this.$vs.loading.close()
      const taskIndex =  this.ownerOfPdvs.findIndex((t) => t.id === task.id)
      Object.assign(this.ownerOfPdvs[taskIndex], task)
    },
    VoirData (data) {
      this.activePrompt3 = true

      // On prépare le tableau des bénéficiaires avec le bon lien photo
      this.bene_object = data.recipients.map((recipient) => {
        let file = recipient.file || ''
        // On applique le substring selon le contexte
        if (file) {
          if (this.rechCheck) {
            if (this.updatecreate) {
              file = file.substring(16)
            } else {
              file = file.substring(46)
            }
          } else if (this.updatecreate) {
            file = file.substring(16)
          } else {
            file = file.substring(46)
          }
          // Ajoute le lien complet si ce n'est pas déjà une URL
          if (file && !file.startsWith('http')) {
            file = link + file
          }
        }
        return {
          fullName: recipient.fullName,
          birthdate: recipient.birthdate,
          recipient: recipient.recipient,
          file
        }
      })

    },

    openfiles (file) {
      if (this.updatecreate === true) {
        this.name_img = file.split('uploads/uploads/')[1]
        this.imageUrl = file
        this.activePrompt4 = true
        //window.open(`${ link  }${file}`, '_blank')
      } else if (this.updatecreate === false) {
        this.name_img = file.substring(39)
        this.imageUrl = file
        this.activePrompt4 = true
        //window.open(`${ link  }${file}`, '_blank')
      }
    },
 
    Voirpicture (data) {
      if (this.search_rech) {
        if (this.updatecreate === true) {
          const cutImage = data.memberPicture.split('uploads/uploads/')[1]
          this.name_img = cutImage
          this.imageUrl = link + cutImage
          this.activePrompt4 = true
          //window.open(`${ link  }${(cutImage)}`, '_blank')


        } else if (this.updatecreate === false) {
          this.name_img = (data.memberPicture).substring(46)
          this.imageUrl = link + (data.memberPicture).substring(46)
          this.activePrompt4 = true

          //window.open(`${ link  }${(data.memberPicture).substring(46)}`, '_blank')
        }
      } else if (!this.search_rech) {
        if (this.updatecreate === true) {
          const cutImage = data.memberPicture.split('uploads/uploads/')[1]
          this.name_img = cutImage
          this.imageUrl = link + cutImage
          this.activePrompt4 = true

          //window.open(`${ link  }${(cutImage)}`, '_blank')

        } else if (this.updatecreate === false) {
          this.name_img = (data.memberPicture).substring(46)
          this.imageUrl = link + (data.memberPicture).substring(46)
          this.activePrompt4 = true

          //window.open(`${ link  }${(data.memberPicture).substring(46)}`, '_blank')
        }
      }
   
    },
    VoirpictureSearch (data) {
      if (this.updatecreate === true) {
        const cutImage = data.memberPicture.split('uploads/uploads/')[1]
        this.name_img = cutImage
        this.imageUrl = link + cutImage
        this.activePrompt4 = true
        //window.open(`${ link  }${(cutImage)}`, '_blank')
      } else if (this.updatecreate === false) {
        this.name_img = (data.memberPicture).substring(46)
        this.imageUrl = link + (data.memberPicture).substring(46)
        this.activePrompt4 = true
        // window.open(`${ link  }${(data.memberPicture).substring(46)}`, '_blank')
      }
    },
    editData (data) {
      this.intialise()
      this.activePrompt1 = true
      this.id = data.id
      this.fullName = data.fullName
      this.branch = data.branch.id
      this.gender = data.gender
      this.phoneNumber = data.phoneNumber
      this.birthdate = data.birthdate
      this.email = data.email
      this.address = data.address
      this.maritalStatus = data.maritalStatus

      // Gestion des bénéficiaires (persons_computed)
      if (data.recipients && Array.isArray(data.recipients)) {
        this.persons_computed = data.recipients.map((recipient) => {
          let file = recipient.file || ''
          if (file) {
            if (this.rechCheck) {
              file = this.updatecreate ? file.substring(16) : file.substring(46)
            } else {
              file = this.updatecreate ? file.substring(16) : file.substring(46)
            }
            if (file && !file.startsWith('http')) {
              file = link + file
            }
          }
          return {
            id_person: this.id_produit++,
            fullName: recipient.fullName,
            birthdate: recipient.birthdate,
            recipient: recipient.recipient,
            file
          }
        })
      } else {
        this.persons_computed = []
      }
      // Gestion de la photo du bénéficiaire 1
      /*  if (data.recipient1file1) {
        let file1 = data.recipient1file1
        if (this.rechCheck) {
          file1 = this.updatecreate ? file1.substring(8) : file1.substring(69)
        } else {
          file1 = this.updatecreate ? file1.substring(8) : file1.substring(46)
        }
        this.name_file1_1 = file1
        this.dataImgView1_1 = file1.startsWith('http') ? file1 : link + file1
      } else {
        this.name_file1_1 = ''
        this.dataImgView1_1 = ''
      } */

      // Gestion de la photo adhérent (memberPicture)
      if (data.memberPicture) {
        let file6 = data.memberPicture
        if (this.rechCheck) {
          file6 = this.updatecreate ? file6.substring(16) : file6.substring(46)
        } else {
          file6 = this.updatecreate ? file6.substring(16) : file6.substring(46)
        }
        this.name_file6 = file6
        this.dataImgView6 = file6.startsWith('http') ? file6 : link + file6
        this.memberPicture = file6.startsWith('http') ? file6 : link + file6
      } else {
        this.name_file6 = ''
        this.dataImgView6 = ''
        this.memberPicture = ''
      }
    },
   
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    getAllcorporates () {
      this.$vs.loading()
      this.$http.get('corporates/')
        .then((response) => {
          this.corporates = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getAllAgents () {
      this.$http.get('agents/')
        .then((response) => {
          this.agents = response.data
        })
        .catch(() => {
        })
    },
    getAllbranches () {
      this.$http.get('branches/')
        .then((response) => {
          this.branches = response.data
        })
        .catch(() => {
        })
    },
    getAllownerOfPdvs () {
      this.$vs.loading()
      this.$http.get('ownerOfPdvs/')
        .then((response) => {
          this.ownerOfPdvs = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    async fetchAllPaginatedOwnerOfPdvs () {
      if (this.page === 0) {
        let page = 1
        let allResults = []
        let hasNext = true
        const baseUrl = `${str}paginated-ownerOfPdvs/`
        const firstResponse = await this.$http.get(baseUrl, { params: { page: 1 } })
        const totalCount = firstResponse.data.count
        const itemsPerPage = 50
        const totalPages = Math.ceil(totalCount / itemsPerPage)
        const maritalStatusMap = { single: 'Célibataire', married: 'Marié', divorced: 'Divorcé', widowed: 'Veuf(ve)' }
        const genderMap = { male: 'Masculin', female: 'Féminin' }
        let response = firstResponse
        while (hasNext && !this.isDestroyed) { // <-- vérifie le flag
          const transformedResults = response.data.results.map(item => ({
            ...item,
            maritalStatus: maritalStatusMap[item.maritalStatus] || item.maritalStatus,
            gender: genderMap[item.gender] || item.gender
          }))
          allResults = allResults.concat(transformedResults)
          this.page = Math.round((page / totalPages) * 100)
          hasNext = !!response.data.next
          page += 1
          if (hasNext && !this.isDestroyed) {
            response = await this.$http.get(baseUrl, { params: { page } })
          }
        }
        this.page = 100
        return allResults
      } else if (this.page === 100) {
        this.page = 0
      } else {
        this.$vs.notify({
          time: 4000,
          title: 'ATTENTION',
          text: 'Un téléchargement est déjà en cours.',
          color: 'warning',
          position: 'top-center'
        })
      }
      
    },

    /* async fetchAllPaginatedOwnerOfPdvs () {
      let page = 1
      let allResults = []
      let hasNext = true
      const baseUrl = 'paginated-ownerOfPdvs/'
      while (hasNext) {
        const response = await this.$http.get(baseUrl, { params: { page } })
        allResults = allResults.concat(response.data.results)
        hasNext = !!response.data.next
        page += 1
      }
      this.allOwnerOfPdvs = allResults
    }, */
    getpaginatedownerOfPdvs () {
      this.$vs.loading()
      this.$http.get('paginated-ownerOfPdvs/')
        .then((response) => {
          this.pageCount = 1
          this.ownerOfPdvs = response.data.results
          this.count = response.data.count
          this.repNext = str + (response.data.next).substr(34)
          this.repPrev = response.data.previous
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  },
  created () {
    window.getProspect = this
    document.title = 'TransVie | PDV'
    this.user_role = JSON.parse(localStorage.getItem('userInfo')).role
    this.updatecreate = false
    this.getAllbranches()
    if (this.user_role !== 'agent') {
      this.getAllAgents()
      this.getAllcorporates()
    }
    //this.getAllownerOfPdvs()
    this.getpaginatedownerOfPdvs()
  },
  mounted () {
    this.isMounted = true
  },
  beforeDestroy () {
    this.isDestroyed = true // <-- met le flag à true pour arrêter les appels asynchrones
  }
}
</script>
  
  <style lang="scss">
  .popup-secondaire {
      z-index: 1000000000 !important;
      overflow: visible !important; /* <-- nécessaire pour laisser l'image grandir */
    }
      .image-container {
        display: flex;
        justify-content: center;
        margin-top: 1rem;
        position: relative;
      }

    .decorated-image {
      max-width: 37.5rem;
      border-radius: 12px;
      border: 2px solid #fcfcfd;
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      cursor: zoom-in;
    }

    .decorated-image2 {
      max-width: 4rem;
      border-radius: 12px;
      border: 2px solid #fcfcfd;
      box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .image-container2 {
        display: flex;
        justify-content: left;
        margin-top: 1rem;
        position: relative;
      }

    .decorated-image:hover {
      transform: scale(1.05);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    } 
    .decorated-image.zoomed {
      transform: scale(2.2);
      position: relative; /* <-- nouveau */
      transform-origin: center center;
      z-index: 999;
      cursor: zoom-out;
    } 
    .dropdown-scroll {
      max-height: 200px; // ou une autre hauteur selon ton besoin
      overflow-y: auto;
      width: max-content; // optionnel pour s’adapter au contenu
    }
  #data-list-list-view {
    .vs-con-table {
          /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;
  
          .vs-table--search-input {
            width: 100%;
          }
        }
      }
  
      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }
  
      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;
  
          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }
  
      .product-name {
        max-width: 23rem;
      }
  
      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }
  
        .vs-table--search{
          padding-top: 0;
  
          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;
  
            &+i {
              left: 1rem;
            }
  
            &:focus+i {
              left: 1rem;
            }
          }
        }
      }
  
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
  
        tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 20px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
        }
      }
  
      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;
  
          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }
      .progress-bar-custom {
        border-radius: 40px !important;
        overflow: hidden;
      }
      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  </style>
